'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeRange = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _time = require('helpers/time');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeRange = exports.TimeRange = function TimeRange(_ref) {
  var startTimestamp = _ref.startTimestamp,
      endTimestamp = _ref.endTimestamp;

  var startTime = (0, _time.parseUnixSecondsDate)(startTimestamp);
  var endTime = (0, _time.parseUnixSecondsDate)(endTimestamp);

  return _react2.default.createElement(
    'span',
    { className: 'time-range' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'reservation.date-range',
      defaultMessage: '{startTime, time, short} - {endTime, time, short}',
      values: {
        startTime: startTime,
        endTime: endTime
      }
    })
  );
};

var TimeStampShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired;

TimeRange.propTypes = {
  startTimestamp: TimeStampShape,
  endTimestamp: TimeStampShape
};